import _ from "lodash";

export class Validity {
  constructor(isValid = true, errorMessages = []) {
    this._isValid = isValid
    this._errorMessages = errorMessages
  }

  isValid() {
    return this._isValid
  }

  getErrorMessages() {
    return this._errorMessages
  }

  chain(validity) {
    return new Validity(
      this.isValid() && validity.isValid(),
      [...this.getErrorMessages(), ...validity.getErrorMessages()]
    )
  }
}

export class Validator {
  constructor(
    isValidFn,
    errorMessage = 'invalid'
  ) {
    this.isValidFn = isValidFn
    this._errorMessage = errorMessage
    this._params = []
  }

  withParams(...params) {
    this._params = params
    return this
  }

  withErrorMessage(msg) {
    this._errorMessage = msg
    return this
  }

  getValidity(value, ...args) {
    const isValid = !!this.isValidFn(value, ...args, ...this._params)
    const message = _.isFunction(this._errorMessage) ? this._errorMessage(value, ...args) : this._errorMessage;
    return new Validity(isValid, !isValid ? [message] : void 0)
  }
}

export class Validators {
  constructor(
    validators = []
  ) {
    this.validators = validators
  }

  getValidity(value, ...args) {
    return this.validators.reduce((validity, validator) => validity.chain(validator.getValidity(value, ...args)), new Validity)
  }
}


// WEBPACK FOOTER //
// ./utilities/validation.js